import { HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ApplicationSubmoduleSchema } from '@kros-sk/application-submodules';
import { HttpMockService } from '@kros-sk/core/http-mock';
import { DeviceDetectorFacade } from '@kros-sk/device-detector';

import mobileSchema from './submodule/received-invoice-public-document-mobile.json';
import schema from './submodule/received-invoice-public-document.json';

export const PUBLIC_DOCUMENT_SUBMODULE_URL = '/mock/document-viewer/public-submodule';

interface SubmoduleSchemas {
  desktop: ApplicationSubmoduleSchema;
  mobile: ApplicationSubmoduleSchema;
}

@Injectable()
export class PublicDocumentSubmoduleMockService implements HttpMockService {
  readonly #deviceDetector = inject(DeviceDetectorFacade);

  readonly #map: Record<string, SubmoduleSchemas> = {
    'received-invoice-document': { desktop: schema, mobile: mobileSchema },
  };

  get(req: HttpRequest<unknown>): ApplicationSubmoduleSchema | null {
    if (req.url !== PUBLIC_DOCUMENT_SUBMODULE_URL) {
      return null;
    }

    const submodule = req.params.get('submodule');

    if (!submodule) {
      return null;
    }

    const schemas = this.#map[submodule];

    if (!schemas) {
      return null;
    }

    return this.#deviceDetector.isMobile() ? schemas.mobile : schemas.desktop;
  }
}
